import { useContext, useEffect, useState } from 'react'
import { PileExecutedStatusChangerContext } from './Context'
import { useProjectStore } from 'Store/Project'
import { useParams } from 'react-router-dom'
import { shallow } from 'zustand/shallow'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'

const ViewModel = () => {
  const modalsRoot = document.getElementById('root-modals') || document.body
  const options = [
    {
      label: 'เสียหาย - ซ่อมแซม',
      value: 'repairing',
    },
    {
      label: 'เสียหาย - เปลี่ยน',
      value: 'change-pile',
    },
    {
      label: 'กำลังดำเนินการ',
      value: 'in-progress',
    },
    {
      label: 'เสร็จสิ้น',
      value: 'completed',
    },
  ]

  const { open, setOpen, currentPileHoleId, setCurrentPileHoleId } = useContext(
    PileExecutedStatusChangerContext
  )
  const { id: projectId } = useParams<{ id: string }>()
  const { data, getData, changeStatus } = useProjectStore(
    state => ({
      data: state.pileHoles,
      getData: state.getPileHoles,
      changeStatus: state.changePileHoleStatus,
    }),
    shallow
  )

  const [status, setStatus] = useState<string | null>(null)

  const fetchData = () => {
    if (projectId) {
      getData(parseInt(projectId)).then(({ success, data }) => {
        if (!success) {
          toast.error(`Fetch data failed : ${data}`)
        }
      })
    } else {
      Swal.fire({
        icon: 'error',
        text: 'Project ID is not found',
      }).then(() => {
        setOpen(false)
      })
    }
  }

  const onClose = () => {
    setOpen(false)
    setCurrentPileHoleId(undefined)
    setStatus(null)
  }

  const onChangeStatus = (status: string) => {
    setStatus(status)
  }

  const onSubmit = () => {
    if (status && currentPileHoleId && projectId) {
      changeStatus(projectId ?? '', currentPileHoleId ?? '', status).then(({ success, data }) => {
        if (success) {
          toast.success('Change status successfully')
          fetchData()
          onClose()
        } else {
          toast.error(`Change status failed : ${data}`)
        }
      })
    }
  }

  const handleSetInitialState = () => {
    if (open) {
      const finded = data.find(item => item.id === parseInt(currentPileHoleId ?? '0'))
      if (finded) {
        setStatus(finded.status)
      }
    }
  }

  useEffect(() => {
    handleSetInitialState()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, data, currentPileHoleId])

  return {
    modalsRoot,
    options,
    open,
    status,
    onClose,
    onSubmit,
    onChangeStatus,
  }
}

export default ViewModel
